import Button from "components/common/Button";
import useBottomSheet from "hooks/common/useBottomSheet";
import { useEffect, useState } from "react";

const PrimeSwipeCallEnd = () => {
    const { sheets, closeWithAnimation } = useBottomSheet();
    const sheet = sheets.PrimeSwipeCallEnd;
    const { bjUid } = sheet.data;
    const [bjUserInfo, setbjUserInfo] = useState<UserInfo | null>(null);

    useEffect(() => {
        if (!bjUid) {
            return;
        }

        FriendsDataManager.getInfo(bjUid, (uid:string, profile:any) => {
            if (!uid) {
                return;
            }
            setbjUserInfo(profile);
        });
    },[bjUid]);

const handleSwipe = () => {
    closeWithAnimation(sheet.id);
    FindUI.find();
};

  return <div className="flex flex-col justify-center items-center">
    <div className="typography-headline-md text-center">{brsc.sheet_swipecall_ended}</div>
    <div className="relative flex rounded-xl overflow-hidden w-[50vw] h-[50vw] my-4">
        {bjUserInfo && <img className="w-full h-full object-cover" src={PhotoManager.getPrimePhotoURL(bjUserInfo, true)} alt="" />}
        {!bjUserInfo && <div className="w-full h-full bg-base-bg-subtle" />}
        {bjUserInfo && <div className="absolute start-0 bottom-2 flex gap-1 items-center justify-center text-center w-full">
            {<img className="flag" width="24" height="16" src={`/images/nation_flag/${bjUserInfo.country.toLowerCase()}.svg`} alt="" />}
            {<div className="typography-headline-sm text-base-txt-white">{bjUserInfo.nick}</div>}
        </div>}
    </div>
    <Button 
        onClick={handleSwipe} 
        className="px-4 mt-5 mb-4 w-full"
        style={{ text: brsc.btn_find_new_partner, color: 'btn-bg-primary', borderRadius: 'lg' }}
    />
  </div>;
};

export default PrimeSwipeCallEnd;